import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SIDE_PANEL_WIDTH, PDF_CONTENT_MARGIN } from '../../constants';

export default function CentredComponent({ children, sidePanelOpen, clientWidth }) {
  const freeWidth = sidePanelOpen ? clientWidth - SIDE_PANEL_WIDTH : clientWidth;
  const width = Math.min(freeWidth, 1000) - PDF_CONTENT_MARGIN;
  const className = classnames('centred-component', {
    'bigger-margin-left': sidePanelOpen,
  });
  return (
    <div className={className} style={{ width }}>{children}</div>
  );
}

CentredComponent.propTypes = {
  sidePanelOpen: PropTypes.bool,
  clientWidth: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

CentredComponent.defaultProps = {
  sidePanelOpen: false,
};
